/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './notes-list/notes-list.component.ngfactory';
import * as i4 from './auth/signup/signup.component.ngfactory';
import * as i5 from './auth/login/login.component.ngfactory';
import * as i6 from './note-detail/note-detail.component.ngfactory';
import * as i7 from './about/about.component.ngfactory';
import * as i8 from './app.component.ngfactory';
import * as i9 from '@angular/common';
import * as i10 from '@angular/platform-browser';
import * as i11 from '@angular/forms';
import * as i12 from '@angular/http';
import * as i13 from '@angular/router';
import * as i14 from 'angularfire2/app/firebase.app.module';
import * as i15 from 'angularfire2/angularfire2';
import * as i16 from 'angularfire2/auth/auth';
import * as i17 from '../../app/auth/auth.service';
import * as i18 from '../../app/auth/auth-guard.service';
import * as i19 from 'angularfire2/database/database';
import * as i20 from '../../app/service/data.service';
import * as i21 from '../../app/notes-list/notes-list.component';
import * as i22 from '../../app/auth/signup/signup.component';
import * as i23 from '../../app/auth/login/login.component';
import * as i24 from '../../app/note-detail/note-detail.component';
import * as i25 from '../../app/about/about.component';
import * as i26 from '../../app/app-routing.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.NotesListComponentNgFactory,i4.SignupComponentNgFactory,i5.LoginComponentNgFactory,
              i6.NoteDetailComponentNgFactory,i7.AboutComponentNgFactory,i8.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i9.NgLocalization,i9.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i10.DomSanitizer,i10.ɵe,[i10.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i10.DomSanitizer]),i0.ɵmpd(4608,
              i10.HAMMER_GESTURE_CONFIG,i10.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i10.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i10.ɵDomEventsPlugin(p0_0),new i10.ɵKeyEventsPlugin(p1_0),
                    new i10.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i10.DOCUMENT,i10.DOCUMENT,i10.DOCUMENT,i10.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i10.EventManager,i10.EventManager,[i10.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i10.ɵDomSharedStylesHost,i10.ɵDomSharedStylesHost,
              [i10.DOCUMENT]),i0.ɵmpd(4608,i10.ɵDomRendererFactory2,i10.ɵDomRendererFactory2,
              [i10.EventManager,i10.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,
              (null as any),[i10.ɵDomRendererFactory2]),i0.ɵmpd(6144,i10.ɵSharedStylesHost,
              (null as any),[i10.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,
              i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i10.Meta,i10.Meta,[i10.DOCUMENT]),
          i0.ɵmpd(4608,i10.Title,i10.Title,[i10.DOCUMENT]),i0.ɵmpd(4608,i11.FormBuilder,
              i11.FormBuilder,([] as any[])),i0.ɵmpd(4608,i11.ɵi,i11.ɵi,([] as any[])),
          i0.ɵmpd(4608,i12.BrowserXhr,i12.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i12.ResponseOptions,
              i12.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i12.XSRFStrategy,
              i12.ɵb,([] as any[])),i0.ɵmpd(4608,i12.XHRBackend,i12.XHRBackend,[i12.BrowserXhr,
              i12.ResponseOptions,i12.XSRFStrategy]),i0.ɵmpd(4608,i12.RequestOptions,
              i12.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i12.Http,i12.ɵc,[i12.XHRBackend,
              i12.RequestOptions]),i0.ɵmpd(5120,i13.ActivatedRoute,i13.ɵf,[i13.Router]),
          i0.ɵmpd(4608,i13.PreloadAllModules,i13.PreloadAllModules,([] as any[])),
          i0.ɵmpd(6144,i13.PreloadingStrategy,(null as any),[i13.PreloadAllModules]),
          i0.ɵmpd(135680,i13.RouterPreloader,i13.RouterPreloader,[i13.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i13.PreloadingStrategy]),i0.ɵmpd(4608,i13.NoPreloading,
              i13.NoPreloading,([] as any[])),i0.ɵmpd(5120,i13.ROUTER_INITIALIZER,
              i13.ɵi,[i13.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i13.ROUTER_INITIALIZER]),i0.ɵmpd(5120,i14.FirebaseApp,i14._firebaseAppFactory,
              [i14.FirebaseAppConfigToken,i15.FirebaseAppName]),i0.ɵmpd(4608,i16.AngularFireAuth,
              i16.AngularFireAuth,[i14.FirebaseApp]),i0.ɵmpd(4608,i17.AuthService,
              i17.AuthService,[i16.AngularFireAuth]),i0.ɵmpd(4608,i18.AuthGuard,i18.AuthGuard,
              [i17.AuthService,i13.Router]),i0.ɵmpd(4608,i19.AngularFireDatabase,i19.AngularFireDatabase,
              [i14.FirebaseApp]),i0.ɵmpd(4608,i20.DataService,i20.DataService,[i17.AuthService,
              i19.AngularFireDatabase]),i0.ɵmpd(512,i9.CommonModule,i9.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i10.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i13.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i13.ɵg,i13.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i10.ɵc(p0_0,p0_1),i13.ɵh(p1_0)];
              },[[2,i10.NgProbeToken],[2,i0.NgProbeToken],i13.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i10.BrowserModule,i10.BrowserModule,[[3,i10.BrowserModule]]),
          i0.ɵmpd(512,i11.ɵba,i11.ɵba,([] as any[])),i0.ɵmpd(512,i11.ReactiveFormsModule,
              i11.ReactiveFormsModule,([] as any[])),i0.ɵmpd(512,i12.HttpModule,i12.HttpModule,
              ([] as any[])),i0.ɵmpd(1024,i13.ɵa,i13.ɵd,[[3,i13.Router]]),i0.ɵmpd(512,
              i13.UrlSerializer,i13.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i13.ChildrenOutletContexts,i13.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(256,i13.ROUTER_CONFIGURATION,{preloadingStrategy:i13.PreloadAllModules},
              ([] as any[])),i0.ɵmpd(1024,i9.LocationStrategy,i13.ɵc,[i9.PlatformLocation,
              [2,i9.APP_BASE_HREF],i13.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i9.Location,
              i9.Location,[i9.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i13.ROUTES,
              () => {
                return [[{path:'',component:i21.NotesListComponent,canActivate:[i18.AuthGuard]},
                    {path:'signup',component:i22.SignupComponent},{path:'login',component:i23.LoginComponent},
                    {path:'note',component:i24.NoteDetailComponent,canActivate:[i18.AuthGuard]},
                    {path:'note/:id',component:i24.NoteDetailComponent,canActivate:[i18.AuthGuard]},
                    {path:'about',component:i25.AboutComponent}]];
              },([] as any[])),i0.ɵmpd(1024,i13.Router,i13.ɵe,[i0.ApplicationRef,i13.UrlSerializer,
              i13.ChildrenOutletContexts,i9.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i13.ROUTES,i13.ROUTER_CONFIGURATION,[2,i13.UrlHandlingStrategy],
              [2,i13.RouteReuseStrategy]]),i0.ɵmpd(512,i13.RouterModule,i13.RouterModule,
              [[2,i13.ɵa],[2,i13.Router]]),i0.ɵmpd(512,i26.AppRoutingModule,i26.AppRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i15.AngularFireModule,i15.AngularFireModule,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),
          i0.ɵmpd(256,i14.FirebaseAppConfigToken,{apiKey:'AIzaSyAstce9i61SuUhj1Z1YX9Dd8f8_ooIoHLo',
              authDomain:'firenotes-1867f.firebaseapp.com',databaseURL:'https://firenotes-1867f.firebaseio.com',
              projectId:'firenotes-1867f',storageBucket:'firenotes-1867f.appspot.com',
              messagingSenderId:'653463931193'},([] as any[])),i0.ɵmpd(256,i15.FirebaseAppName,
              (undefined as any),([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2RhcnlsYmVyZ2Vyb24vRG9jdW1lbnRzL3dlYnN0dWZmL2FuZ3VsYXIvZmlyZW5vdGVzL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9kYXJ5bGJlcmdlcm9uL0RvY3VtZW50cy93ZWJzdHVmZi9hbmd1bGFyL2ZpcmVub3Rlcy9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts